import "./AddKeywords.scss";
import { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";
import { Field, Formik } from "formik";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../../Services/Interceptor/Interceptor";
import API_END_POINTS from "../../../Utilities/Constants/ApiEndpoints";
import {
  VALIDATION_CONSTANT,
  TOASTER_CONFIGS,
  ROUTES,
  UPLOAD_TICKET_CONSTANT,
  I18_TRANSLATION_COMMON,
} from "../../../Utilities/Constants/Constants";
import {
  ERROR_MESSAGES,
  REGEX,
} from "../../../Utilities/Constants/Validations";
import plus from "../../../../Assets/tags/plus.svg";
import backButton from "../../../../Assets/schools/back_button.svg";
import { nullUndefinedEmptyCheck } from "../../../Services/Helpers/Helper";
import { List, ListItemButton, ListItemText, MenuItem, Select } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const AddKeywords = () => {
  const { id } = useParams();
  const [courseType, setCourseType] = useState();
  const [categoryList, setCategoryList] = useState([]);
  const [tagList, setTagList]: any = useState([]);
  const [currentTag, setCurrentTag] = useState("");
  const [currentCategory, setCurrentCategory]: any = useState();
  const navigate = useNavigate();
  const { t } = useTranslation(I18_TRANSLATION_COMMON.COMMON);
  const [course, setCourse] = useState("");
  const [initialRender, setInitialRender] = useState(true);
  const [ arabictag, setArabictag ] = useState('');
  const [ englishtag, Setengilshtag ] = useState("");
  const [ eataglist, setEataglist ]:any = useState([])



  const location = useLocation();

  const isPathActive = (path: string) => {
    return location.pathname.startsWith(path);
  };


  
  useEffect(() => {
    location.pathname.split("/")[1] ===
    UPLOAD_TICKET_CONSTANT.MANAGE_RECREATIONAL
      ? setCourseType(VALIDATION_CONSTANT.RECREATION)
      : setCourseType(VALIDATION_CONSTANT.COURSE);
  }, []);

 
  useEffect(() => {
    if (courseType) {
      if (id) {
        tageDetail();
      } else {
        getCategoryList();
      }
    }
  }, [courseType]);

 
  const tageDetail = () => {
    axiosInstance
      .get(
        API_END_POINTS.GET_TAG_DETAIL +
          "?category_type=" +
          courseType +
          "&category_id=" +
          id
      )
      .then((res: any) => {
        if (res.data.status === true) {
          setTagList(res.data.result.data);
          setCurrentCategory(res.data.result.category);
          setCourse(res.data.result.category);
        }
      });
  };

 
  const onTypeChange = (event: any) => {
    setCourseType(event.target.value);
    setTagList([]);
    setCurrentCategory("");
    setCategoryList([]);
  };

 
  const onCategorySelect = (event: any) => {
    setTagList([]);
    setCurrentCategory(event.target.value);
  };

 
  const currentLanguage = useSelector((state: any) => {
    return state.languageReducer.language;
  });

 
  const getCategoryList = () => {
    if (courseType === VALIDATION_CONSTANT.COURSE) {
      axiosInstance.get(API_END_POINTS.GET_ALLCOURSE_LIST).then((res: any) => {
        if (res.data.status === true) {
          setCategoryList(res.data.result.data);
          
          
        }
      });
    } else if (courseType === VALIDATION_CONSTANT.RECREATION) {
      axiosInstance
        .get(API_END_POINTS.GET_ALLRECREATIONAL_LIST)
        .then((res: any) => {
          if (res.data.status === true) {
            setCategoryList(res.data.result.data);
            
            
          }
        });
    }
  };

 
  const onAddTag = () => {
    if (
      currentTag.trim() !== "" &&
      tagList.filter((item: any) => item === currentTag).length === 0
    ) {
      setTagList([...tagList, currentTag]);
    } else {
      if (currentTag.trim() !== "") toast.error(ERROR_MESSAGES.TAG_VALIDATION);
    }
    setCurrentTag("");
  };

 
  useEffect(() => {}, [tagList]);

 
  const setInputValue = (e: any) => {
    if (
      REGEX.ENGLISH_INPUT_VALIDATION.test(e.target.value) &&
      !/[0-9.]/.test(e.key)
    ) {
      setCurrentTag(e.target.value);
    }
  };

 
  const handleDelete = (i: any) => () => {
    setTagList(tagList.filter((item: any) => item !== tagList[i]));
  };

 
  const handleKeyPress = (event: any) => {
    if (
      event.key === VALIDATION_CONSTANT.KEY_TYPE &&
      event.target.value.trim() !== ""
    ) {
      onAddTag();
    }
  };

 
  const onSaveTags = () => {
    let payload = {
      category_type: courseType,
      category: currentCategory,
      eatags: eataglist,
    };
    axiosInstance.post(API_END_POINTS.CREATE_TAGS, payload).then((res) => {
      if (res.data.status === true) {
        toast.success(res.data.message, TOASTER_CONFIGS);
        courseType === VALIDATION_CONSTANT.RECREATION
          ? navigate(ROUTES.RECREATIONAL_KEYWORDS)
          : navigate(ROUTES.COURSE_KEYWORDS);
      }
    });
  };

  return (
    <div
      className="categories_wrapper"
      dir={currentLanguage === "English" ? "ltr" : "rtl"}
    >
      <div className="page-title">
        <img
          className="arrow_icon"
          src={backButton}
          alt="Learn and Play"
          onClick={() => {
            courseType === VALIDATION_CONSTANT.RECREATION
              ? navigate(ROUTES.RECREATIONAL_KEYWORDS)
              : navigate(ROUTES.COURSE_KEYWORDS);
          }}
        />
        <h5 className="name-title">{t("Add Tags")}</h5>
      </div>
      <div className=" tags-wrap box-wrapper">
        <div className="row">
          <div className="col-md-5">
            <div className="tag-select-wrap">
              <label className="name-label">{t("Category Type")}</label>
              <input
                className="tag-input category-type"
                value={courseType}
                disabled
              />
            </div>

            {courseType == "course" && !id && (
              <div className="tag-select-wrap category-select">
                <label className="name-label">{t("Category")}:</label>
                <select
                  className="course-type-selection"
                  onChange={onCategorySelect}
                >
                  <option value="">{t("Please select category")}</option>
                  {categoryList.map((element: any, index: any) => {
                    return (
                      <option
                        className="categorylist-option"
                        value={element.id}
                      >
                        {currentLanguage == "English"
                          ? element.course_category_name
                          : element.arabic_coursecategory_name}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}

            {courseType == "recreation" && !id && (
              <div className="tag-select-wrap category-select">
                <label className="name-label">{t("Category")}:</label>
                <select
                  className="course-type-selection"
                  onChange={onCategorySelect}
                >
                  <option value="">{t("Please select category")}</option>
                  {categoryList.map((element: any, index: any) => {
                    return (
                      <option value={element.id}>
                        {element.category_name}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}

            {courseType == "course" && id && (
              <div className="tag-select-wrap category-select">
                <label className="name-label">{t("Category")}:</label>
                <input
                  className="tag-input category-type"
                  value={course}
                  disabled
                />
              </div>
            )}
          </div>
          <div className="col-md-7">
            {(courseType === "recreation" || courseType == "course") &&
              currentCategory &&
              currentCategory !== "" && (


              <div className="row school-row-wrap">
              <div id="card-title" className="mandatory_fields">{t("Tags")}</div>
              <div className="">
                <div>
                  <div className="application-btn-wrapper">
                    <input
                      className="form_inputs mb-3"
                      placeholder={t("Engilsh Tag")}
                      onChange={(e: any) => {
                        Setengilshtag(e.target.value);
                      }}
                      value={englishtag}
                    />
                    <input
                      className="form_inputs mb-3"
                      placeholder={t("Arabic Tag")}
                      onChange={(e: any) => {
                        setArabictag(e.target.value);
                      }}
                      
                      value={arabictag}
                    />
                    <button
                      type="button"
                      className="btn add-btn"
                      onClick={() => {
                        if (
                          nullUndefinedEmptyCheck(englishtag) &&
                          nullUndefinedEmptyCheck(arabictag)
                        ) {
                          let data: any = eataglist;
                          let obj = {
                            
                            ["tag"]:englishtag,
                            ["arabic_tag_name"]:arabictag
                          };
                          data.push(obj);
                          setEataglist([...data]);
                          Setengilshtag("");
                          setArabictag("");
                        }
                      }}
                    >
                      Add
                    </button>
                  </div>
             
                  {eataglist?.length > 0 && (
                    <div className="event-wrap">
                      <List>
                        {eataglist.map((point: any, index: any) => {
                          
                          return (
                            <div key={index}>
                              <ListItemButton className="list-btn">
                                <ListItemText primary={`${point.tag} : ${point.arabic_tag_name}`} />
                                <DeleteIcon
                                  onClick={() => {
                                    let data: any = eataglist.slice();
                                    data.splice(index, 1);
                                    setEataglist(data);
                                  }}
                                />
                              </ListItemButton>
                            </div>
                          );
                        })}
                      </List>
                    </div>
                  )}
                  <div className="error-message-wrap mt-2">
                    {eataglist?.length === 0 && (
                      <div className="errorMessage">
                        {t("select correctly")}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>


                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                
                

                
                
                
                
                
                
                
                
                
                
                
                
                
              )}
          </div>
        </div>
      </div>
      <div className="save-tag">
        <button
          className="cancel_button"
          onClick={() => {
            courseType === VALIDATION_CONSTANT.RECREATION
              ? navigate(ROUTES.RECREATIONAL_KEYWORDS)
              : navigate(ROUTES.COURSE_KEYWORDS);
          }}
        >
          {t("Cancel")}
        </button>
        <button type="submit" className="save_button" onClick={onSaveTags}>
          {t("Save")}
        </button>
      </div>
    </div>
  );
};

export default AddKeywords;
